import type { CSSProperties, HTMLAttributes, ReactNode } from 'react'
import { cx } from './utils/cx'

export type CardVariant = 'lg' | 'hero' | 'well' | 'ink'

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: CardVariant
  children?: ReactNode
  style?: CSSProperties
}

export function Card({ variant, children, className, style, ...rest }: CardProps) {
  return (
    <div className={cx('st-card', variant, className)} style={style} {...rest}>
      {children}
    </div>
  )
}
